// Static CSS files.
import ceo from "./css/ceo";
import graphite from "./css/graphite";

function table(theme) {
  let renderTheme;

  switch (theme) {
    case "ceo":
      renderTheme = ceo;
      break;

    case "graphite":
      renderTheme = graphite;
      break;

    default:
      renderTheme = graphite;
      break;
  }

  return renderTheme;
}

export default table;